import { Box, Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import theme from "../../../theme";
import { ReservaForm } from "../../public/reserves/Reserves";

function DialogAddReserva({ open, setOpen, setUpdate }) {
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog onClose={handleClose} open={open} maxWidth="lg">
            <DialogTitle sx={{ background: theme.color.primary, color: "white" }}>Nova reserva</DialogTitle>
            <DialogContent sx={{ background: theme.color.primary, padding: 0, color: "white" }}>
                <Box position={"relative"} minWidth={300} minHeight={300}>
                    <ReservaForm admin setOpen={setOpen} setUpdate={setUpdate} />
                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default DialogAddReserva;
